import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { SelectSchema } from "@app/components/forms/types/schema";
import { cn } from "@shortsworks/ui/lib/utils";

export const FormSelect = ({
  form,
  schema,
  ...rest
}: FormItemProps<SelectSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border && "rounded-md border p-3 shadow-sm",
          )}
        >
          <div
            className={cn(
              "space-y-2",
              schema.layout === "horizontal" &&
                "flex flex-row items-start justify-between space-x-2 space-y-0",
            )}
          >
            <div className="flex flex-col space-y-1">
              <FormLabel>
                {typeof schema.label === "function"
                  ? schema.label(form.getValues())
                  : schema.label}
              </FormLabel>
              {schema.layout === "horizontal" && schema.description && (
                <FormDescription>{schema.description}</FormDescription>
              )}
            </div>
            {/*<div>*/}
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger
                  disabled={schema.behavior?.disabled}
                  id={schema.id}
                  className={cn(
                    "items-center [&_[data-description]]:hidden",
                    schema.layout === "horizontal" && "w-fit",
                  )}
                >
                  <SelectValue placeholder={schema.placeholder} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {schema.options?.map((option: any) => (
                  <SelectItem key={option.value} value={option.value}>
                    <div className="flex items-start gap-3 text-muted-foreground">
                      {option.icon}
                      <div className="grid gap-0.5">
                        <p>
                          <span className="font-medium text-foreground">
                            <FormLabel>
                              {typeof schema.label === "function"
                                ? option.label(form.getValues())
                                : option.label}
                            </FormLabel>
                          </span>
                        </p>
                        {option.description && (
                          <div className="text-xs" data-description>
                            {option.description}
                          </div>
                        )}
                      </div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {/*</div>*/}
            {schema.layout !== "horizontal" && schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
